import React from "react";
import styled, { css } from "styled-components";

import { SupportTicketPriority } from "src/modules/support/api/support.api";
import IconDropdown from "src/library/components/IconDropdown/IconDropdown";
import { ThemeType } from "src/library/utils";

interface SupportPriorityDropdownProps {
  // the current selected priority
  priority?: SupportTicketPriority;
  // handles update to the priority level f
  handleUpdate: (priority: SupportTicketPriority) => void
}

// Support ticket priority levels used to drive the dropdown selection
const priorityLevels = () => [
  {
    label: "Low",
    value: SupportTicketPriority.Low,
    icon: <PriorityIcon level={SupportTicketPriority.Low} />
  },
  {
    label: "Medium",
    value: SupportTicketPriority.Medium,
    icon: <PriorityIcon level={SupportTicketPriority.Medium} />
  },
  {
    label: "High",
    value: SupportTicketPriority.High,
    icon: <PriorityIcon level={SupportTicketPriority.High} />
  },
  {
    label: "Urgent",
    value: SupportTicketPriority.Urgent,
    icon: <PriorityIcon level={SupportTicketPriority.Urgent} />
  }
];

/**
 * @description Displays and allows updates to the priority level for a support ticket.
 */
const SupportPriorityDropdown: React.FC<SupportPriorityDropdownProps> = ({ handleUpdate, priority }) => {
  return (
    <IconDropdown
      onSelect={(value: string) => {
        if (!Object.values(SupportTicketPriority).includes(value as SupportTicketPriority)) {
          return;
        }

        // handle update
        handleUpdate(value as SupportTicketPriority);
      }}
      items={priorityLevels()}
      currentSelection={priority}
    />
  );
};

export default SupportPriorityDropdown;

export const PriorityIcon = styled.div<{level: SupportTicketPriority}>`
  ${({ theme, level }) => {
    let backgroundColor;

    switch (level) {
      case "low": {
        backgroundColor = theme.colors.success;
        break;
      }
      case "medium": {
        backgroundColor = theme.colors.mediumBlue || "#4DA1FF";
        break;
      }
      case "high": {
        backgroundColor = theme.colors.warn;
        break;
      }
      case "urgent": {
        backgroundColor = theme.colors.error;
        break;
      }
      default:{
        throw new Error("Invalid priority level");
      }
    }

    return css`
      width: 10px;
      height: 10px;
      background-color: ${backgroundColor};
    `;
  }
}
`;
